import { Controller } from "@hotwired/stimulus"

// The egg's link, handed on. A phone opens its own share sheet (the apps the
// keeper actually posts from); anywhere else the link is copied and the
// button says so. The field stays on the page either way, selectable, for a
// browser that allows neither.
export default class extends Controller {
  static targets = ["field", "status"]
  static values = { url: String, text: String }

  async share() {
    if (navigator.share && window.matchMedia("(pointer: coarse)").matches) {
      try {
        await navigator.share({ url: this.urlValue, text: this.textValue })
        return
      } catch (error) {
        if (error.name === "AbortError") return
      }
    }

    try {
      await navigator.clipboard.writeText(this.urlValue)
      this.say("Link copied.")
    } catch {
      this.select()
      this.say("Copy the link above.")
    }
  }

  select() {
    if (!this.hasFieldTarget) return
    this.fieldTarget.focus()
    this.fieldTarget.select()
  }

  say(line) {
    if (!this.hasStatusTarget) return
    this.statusTarget.textContent = line
    clearTimeout(this.timer)
    this.timer = setTimeout(() => { this.statusTarget.textContent = "" }, 4000)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
